<template>
  <div>
    <v-expand-transition>
      <div v-if="chips.length">
        <div class="px-4">
          <v-chip-group
            column
            active-class="primary"
          >
            <v-chip
              v-for="(chip, i) in chips"
              :key="i"
              close
              close-icon="ui-icon-close-circle"
              color="primary"
              text-color="bg-gray-0"
              @click:close="handleCloseChip(chip.key)"
            >
              <div class="text-truncate">
                {{ t(chip.name, options) }}
              </div>
            </v-chip>
          </v-chip-group>
          <v-chip
            close-icon="ui-icon-close-circle"
            color="bg-primary"
            text-color="primary"
            @click="handleCloseAll()"
          >
            {{ t('Сбросить все', options) }}
          </v-chip>
        </div>
        <v-divider class="mt-4" />
      </div>
    </v-expand-transition>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import getPriceLabel from 'www/vue_components/common/TheFilters/doctors/components/PriceFilters/functions/getPriceLabel'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: doctorFiltersState } = toRefs(props)

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const filtersStore = useFiltersStore()

const mapChips = {
  gender: { F: 'Женщина', M: 'Мужчина' },
  experience: { 5: 'Стаж от 5 лет', 10: 'Стаж от 10 лет', 15: 'Стаж от 15 лет' },
  category: { 1: 'Вторая категория', 2: 'Первая категория', 3: 'Высшая категория' },
  science: { 1: 'Кандидат наук', 2: 'Доктор наук', 3: 'Профессор' },
}

const chips = computed(() => {
  const filters = doctorFiltersState.value
  const priceChipLabel = getPriceLabel(filters.price)
  const isClinic = doctorFiltersState.value.visitLocation === 'clinic'
  const isHome = doctorFiltersState.value.visitLocation === 'home'

  return ([
    filters.patientAge !== undefined && { name: `${t('Возраст пациента', options.value)}: ${filters.patientAge}`, key: 'patientAge' }, //
    !isHome && priceChipLabel && { name: priceChipLabel, key: 'price' }, //
    filters.experience && { name: mapChips.experience[filters.experience], key: 'experience' }, //
    filters.gender && { name: mapChips.gender[filters.gender], key: 'gender' }, //
    filters.category && { name: mapChips.category[filters.category], key: 'category' }, //
    filters.science && { name: mapChips.science[filters.science], key: 'science' }, //
    filters.isHighRating && { name: 'Высокий рейтинг', key: 'isHighRating' }, //
    filters.disease && { name: filters.disease.name, key: 'disease' }, //
    filters.otherSpeciality && { name: filters.otherSpeciality.name, key: 'otherSpeciality' }, //
    isClinic && filters.isOnlineAppointment && { name: 'Онлайн-запись', key: 'isOnlineAppointment' },
    isClinic && filters.isClubAppointment && { name: 'Клубная цена', key: 'isClubAppointment' },
  ] as { name: string, key: keyof Filters }[]).filter(Boolean)
})

const handleCloseChip = (chipKey: keyof Filters) => {
  if (chipKey === 'price') {
    filtersStore.updateUnsavedFilters({
      price: { from: undefined, to: undefined },
    })
    emit('input', {
      ...doctorFiltersState.value,
      price: { from: undefined, to: undefined },
    })
    return
  }

  filtersStore.updateUnsavedFilters({
    [chipKey]: undefined,
  })
  emit('input', {
    ...doctorFiltersState.value,
    [chipKey]: undefined,
  })
}

const handleCloseAll = () => {
  filtersStore.updateUnsavedFilters({
    speciality: filtersStore.filters.speciality,
    disease: undefined,
    otherSpeciality: undefined,
    experience: undefined,
    gender: undefined,
    category: undefined,
    science: undefined,
    patientAge: undefined,
    isHighRating: undefined,
    isOnlineAppointment: undefined,
    isClubAppointment: undefined,
    price: {
      from: undefined,
      to: undefined,
    },
  })
  emit('input', {
    ...doctorFiltersState.value,
    speciality: filtersStore.filters.speciality,
    disease: undefined,
    otherSpeciality: undefined,
    experience: undefined,
    gender: undefined,
    category: undefined,
    science: undefined,
    patientAge: undefined,
    isHighRating: undefined,
    isOnlineAppointment: undefined,
    isClubAppointment: undefined,
    price: {
      from: undefined,
      to: undefined,
    },
  })
}
</script>
